<script setup lang="ts">
import { computed } from 'vue'
import { errorMessage, label } from './data'

defineProps<{
    error?: boolean
}>()

const emit = defineEmits(['update:group', 'update:checkbox'])

const group = defineModel('group', {
    required: true,
    type: Object as () => Record<string, { val: boolean; disabled: boolean }>,
})

const hasAnyTrueValue = computed(() => Object.values(group.value).some((item) => item.val && !item.disabled))
const hasEveryTrueValues = computed(() =>
    Object.values(group.value)
        .filter((item) => !item.disabled)
        .every((enabledItem) => enabledItem.val),
)

const parentState = computed(() =>
    hasAnyTrueValue.value ? (hasEveryTrueValues.value ? true : 'indeterminate') : false,
)

function handleGroupUpdate(val: boolean) {
    const copy = { ...group.value }
    Object.entries(copy).forEach(([_key, value]) => {
        if (value && !value.disabled) {
            value.val = val
        }
    })
    return copy
}

function handleGroupClick(param: boolean) {
    emit('update:checkbox', param)

    if (!parentState.value || parentState.value === 'indeterminate') {
        emit('update:group', handleGroupUpdate(true))
    } else {
        emit('update:group', handleGroupUpdate(false))
    }
}
</script>

<template>
    <div>
        <PlusBlogLpAtomAccordion
            type="single"
            collapsible
        >
            <PlusBlogLpAtomAccordionItem value="item-1">
                <PlusBlogLpAtomAccordionTrigger class="py-4 font-medium hover:underline">
                    <PlusBlogLpAtomCheckbox
                        v-model:checked="parentState"
                        :disabled="false"
                        :error="error"
                        :error-message="errorMessage"
                        :label="label"
                        @update:checked="handleGroupClick($event)"
                        @click.stop
                    />
                </PlusBlogLpAtomAccordionTrigger>
                <PlusBlogLpAtomAccordionContent class="ml-8 pb-4 pt-0 text-sm *:mb-4">
                    <slot />
                </PlusBlogLpAtomAccordionContent>
            </PlusBlogLpAtomAccordionItem>
        </PlusBlogLpAtomAccordion>
    </div>
</template>
